<template>
  <div>
    <v-navigation-drawer v-model="drawer" app color="grey lighten-4" floating :width="drawerWidth">
      <div :style="'height:' + appbarHeight + 'px'" class="d-flex justify-center align-center pa-6">
        <!-- <v-img src="@/assets/logo.jpg" height="90px" style="padding: 20px"></v-img> -->
        <ophq-logo :height="appbarHeight * 0.5" />
      </div>
      <template v-if="ressources.size > 0">
        <v-list nav>
          <v-list-item-group>
            <template v-for="(step, i) in steps">
              <v-divider :key="'divider-' + step.path" v-if="i != 0" class="mb-2"></v-divider>
              <v-list-item :disabled="(!sas && i != 0) || loading" :key="step.path" link :to="{ path: url + step.path, query: $route.query }">
                <v-list-item-title class="aleo opq-nav-title">
                  <template v-if="!notNumbered">{{ i + 1 }}. </template><ressource :code="step.code"></ressource>
                </v-list-item-title>
                <v-list-item-icon v-if="step.state">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" :color="step.state">{{ icons[step.state] }}</v-icon>
                    </template>
                    <span>{{ tooltips[step.state] }}</span>
                  </v-tooltip>
                </v-list-item-icon>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </template>
      <template v-else>
        <div class="pa-6">
          <v-skeleton-loader
            v-for="i in steps.length"
            :key="i"
            type="text"
            :width="Math.floor(Math.random() * 100) + 100"
            height="45"
          ></v-skeleton-loader>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app :height="appbarHeight" class="">
      <v-app-bar-nav-icon @click="drawer = !drawer" color="primary"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <template v-if="ressources.size > 0">
          <ressource code="titre-formulaire"></ressource>
        </template>
        <template v-else>
          <v-skeleton-loader type="text" width="250" height="15"></v-skeleton-loader>
        </template>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" class="font-weight-bold d-none d-sm-flex" dark link :href="urlPortail">
        <v-icon class="mr-3">mdi-arrow-left</v-icon> Retour au portail
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-sheet class="ml-6 py-4 py-md-8 py-lg-12 px-2 px-md-6 px-lg-12">
        <template v-if="loading">
          <ophq-loading />
        </template>
        <template v-else>
          <estime v-if="showPanier && sas" :sasId="sas.id"></estime>
          <introduction v-show="step == 'introduction'" :endpoint="endpoint" @next-step="next"></introduction>
          <template v-if="sas">
            <div v-for="s in realSteps" :key="s.path">
              <div v-show="step == s.path">
                <headline :code="s.code"></headline>
                <slot name="step" :sas="sas" :path="s.path" :setState="setState" :code="s.code"></slot>
                <v-btn color="primary" dark class="mt-6" x-large @click="next">Enregistrer et continuer</v-btn>
              </div>
            </div>
            <soumission
              v-show="step == 'soumission'"
              :showAlert="formulaireNonValide"
              :validationBackendFailed="validationBackendFailed"
              :soumissionEchouee="soumissionEchouee"
              :messageSoumissionEchouee="messageSoumissionEchouee"
              @submit="submit"
              ref="soumission"
              avecPanier
            ></soumission>
          </template>
        </template>
      </v-sheet>
    </v-main>
  </div>
</template>

<script>
import AppbarBase from "@/mixins/AppbarBase"
import Introduction from "@/components/form_parts/Introduction"
import Soumission from "@/components/form_parts/Soumission"
import ParamFormulaireBase from "@/components/ui/mixins/ParamFormulaireBase"
import FormulaireViewBase from "@/mixins/FormulaireViewBase"
import Estime from "@/components/form_parts/Estime"

export default {
  mixins: [AppbarBase, FormulaireViewBase, ParamFormulaireBase],
  components: {
    Introduction,
    Soumission,
    Estime
  },
  props: {
    drawerWidth: {
      type: Number,
      default: 256
    }
  },
  data() {
    return {
      drawer: true,
      snackbar: false,
      icons: {
        success: "mdi-checkbox-marked-circle-outline",
        warning: "mdi-alert-circle-outline",
        error: "mdi-close-circle-outline"
      },
      tooltips: {
        success: "Étape complétée",
        warning: "Manque d'informations",
        error: "Erreur"
      }
    }
  },

  metaInfo() {
    return {
      title: this.$i18n.t("meta.formulaires.title")
    }
  }
}
</script>

<style scoped lang="scss">
.v-list-item {
  .v-list-item__title.opq-nav-title {
    color: black;
    white-space: pre-wrap;
  }
  &.v-list-item--disabled {
    .v-list-item__title.opq-nav-title {
      color: rgba(0, 0, 0, 0.5);
    }
  }
  &.v-list-item--active {
    .v-list-item__title.opq-nav-title {
      font-weight: 600;
    }
  }
}
</style>
